import CreditLifeQuickQuote from './CreditLifeQuickQuote'

export default CreditLifeQuickQuote
